import { Component, OnInit } from '@angular/core';
import { CdsButtonConfig } from '@cds/ng-core/button';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-back-top',
  templateUrl: './back-top.component.html',
  styleUrls: ['./back-top.component.scss'],
  imports: [CdsButtonModule, CdsLanguageModule],
})
export class BackTopComponent implements OnInit {
  constructor() {}

  config: CdsButtonConfig = {
    size: 'sm',
    style: 'secondary',
  };

  ngOnInit(): void {}

  backTop() {
    const container = document.getElementsByClassName('cds-navigation-content')[0];
    container.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
